"use strict";

(function (global) {
  var AgentSession = {

    /**
     * Поддерживает жизнь сессии Агента веб-доступа.
     *
     * @method WebAccess.agent.keepAlive
     * @return {WebAccess.agent} Объект типа agent.
     */
    keepAlive: function () {
      this.transmitRequest("PING", "", { "SessionID": window.g_UserContextID || '' });
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Начинает новую сессию для агента.
     * @method WebAccess.agent._beginSession
     * @private
     * @return {object}
     */
    beginSession: function () {
      var me = this; 
      var d = $.Deferred();
      log.info('AGENT', '"beginSession" method was called');
      var response = "";
      var params = {
        "UserLanguage": currentCultureName.split("-")[0],
        "UserName": g_User.Name,
        "SystemLanguage": appLang,
        "System": g_SysCode,
        "IsSecured": (document.location.protocol == 'http:' ? 'n' : 'y'),
        "Host": document.location.host,
        "WebLinkServer": g_WebServerName,
        "SessionUpdateTime": typeof SessionUpdateTime !== 'undefined' ? SessionUpdateTime : (10 * 60000),
        "MaxRequestLength": g_MaxJsonRequestLength,
        "NewJobsNotificationToken": "",
        "ClientAffinity": ($.cookie('ARRAffinity') == null ? '' : $.cookie('ARRAffinity'))
      };
      //Получаем токен на запрос уведомлений о новых заданиях
      WA.SRV.call("/Security.asmx/GetOpToken0", { Operation: TOKEN_OPERATION.GET_NEW_JOB_LIST }).done(function (token) {
        params["NewJobsNotificationToken"] = token;

        //Отправляем параметры новой сессии агенту
        me.transmitRequest("BeginSession", "", params).done(function (res) {
          d.resolve(res);
        }).fail(function (res) {
          if (!!res) {
            log.error('AGENT', 'Error in beginSession response: ' + res.message);
          }
          d.reject(res);
        });
      });
      
      
      return d.promise();
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Заканчивает сессию для агента.     
     * @method WebAccess.agent._endSession
     * @private
     * @return {object}
     */
    endSession: function () {
      var proxy = this._proxy;
      var response = "";
      var params = {};

      //Отправляем параметры новой сессии агенту
      this.transmitRequest("EndSession", "", params).fail(function (res) {
        if (!!res) {
          log.error('AGENT', 'Error in endSession response: ' + res.message);
        }
      });
      
      return response;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Устанавливает языковые настройки текущей сессии Агента веб-доступа.
     *
     * @method WebAccess.agent.setLanguage
     * @param  {string} language Текущий язык. Возможные значения: ru, en
     * @return {WebAccess.agent} Объект типа agent.
     */
    setLanguage: function (language) {
      this.transmitRequest("SetLanguage", "", { "Language": language });
      return this;
    }
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  };

  window.AgentSession = AgentSession;
})(window.WebAccess);
